import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  dialogPaper: {
    backgroundColor: 'transparent',
    boxShadow: 'none',
    height: '100%',
    width: '100%',
  },
}));
